import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { LIBRARY_CONFIG } from '../config';
import * as i0 from "@angular/core";
/**
 * use this service instead of the httpClient to make sure
 * some basic headers are already taken care of.
 */
export class ApiService {
  injector;
  libraryConfig;
  http;
  baseUrl;
  constructor(injector, libraryConfig) {
    this.injector = injector;
    this.libraryConfig = libraryConfig;
    this.baseUrl = libraryConfig?.baseUrl;
    this.http = injector.get(HttpClient);
    if (!this.baseUrl) {
      console.warn('ApiService: baseUrl is not provided, api calls will not work. please provide a valid baseUrl to your libConfig!');
    }
  }
  /**
   * a wrapper for the httpClient's GET method
   * - sets some basic headers
   * @param url the part of the url after the baseUrl
   * @param options object containing extra HTTP Headers or params
   * @param apiVersion usually the same for all apis defaults to "1"
   */
  get(url, options = {}, apiVersion) {
    const headers = {
      ...(apiVersion ? {
        'Api-Version': apiVersion
      } : {})
    };
    options.headers = {
      ...headers,
      ...(options.headers || {})
    };
    return this.http.get(this.baseUrl + url, options);
  }
  getBlob(url, options, apiVersion) {
    const headers = {
      ...(apiVersion ? {
        'Api-Version': apiVersion
      } : {})
    };
    options.headers = {
      ...headers,
      ...(options.headers || {})
    };
    return this.http.get(this.baseUrl + url, options);
  }
  /**
   * a wrapper for the httpClient's POST method
   * - sets some basic headers
   * @param url the part of the url after the baseUrl
   * @param payload the data to be sent to the backend
   * @param options object containing extra HTTP Headers or params
   * @param apiVersion usually the same for all apis defaults to "1"
   * @param usePostHeaders determines if post headers should be used, defaults to true
   */
  // to support multiple types of payloads, we use "any" here
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  post(url, payload, options = {}, apiVersion, usePostHeaders = true) {
    const headers = {
      ...(usePostHeaders ? this.getPostHeaders() : {}),
      ...(apiVersion ? {
        'Api-Version': apiVersion
      } : {})
    };
    options.headers = {
      ...headers,
      ...(options.headers || {})
    };
    return this.http.post(this.baseUrl + url, payload, options);
  }
  /**
   * a wrapper for the httpClient's PATCH method
   * - sets some basic headers
   * @param url the part of the url after the baseUrl
   * @param payload the data to be sent to the backend
   * @param options object containing extra HTTP Headers or params
   * @param apiVersion usually the same for all apis defaults to "1"
   */
  // to support multiple types of payloads, we use "any" here
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  patch(url, payload, options = {}, apiVersion) {
    const headers = {
      ...this.getPostHeaders(),
      ...(apiVersion ? {
        'Api-Version': apiVersion
      } : {})
    };
    options.headers = {
      ...headers,
      ...(options.headers || {})
    };
    return this.http.patch(this.baseUrl + url, payload, options);
  }
  /**
   * a wrapper for the httpClient's PUT method
   * - sets some basic headers
   * @param url the part of the url after the baseUrl
   * @param payload the data to be sent to the backend
   * @param options object containing extra HTTP Headers or params
   * @param apiVersion usually the same for all apis defaults to "1"
   */
  // to support multiple types of payloads, we use "any" here
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  put(url, payload, options = {}, apiVersion) {
    const headers = {
      ...this.getPostHeaders(),
      ...(apiVersion ? {
        'Api-Version': apiVersion
      } : {})
    };
    options.headers = {
      ...headers,
      ...(options.headers || {})
    };
    return this.http.put(this.baseUrl + url, payload, options);
  }
  delete(url, options = {}, apiVersion) {
    const headers = {
      ...this.getPostHeaders(),
      ...(apiVersion ? {
        'Api-Version': apiVersion
      } : {})
    };
    options.headers = {
      ...headers,
      ...(options.headers || {})
    };
    return this.http.delete(this.baseUrl + url, options);
  }
  getPostHeaders() {
    return {
      'Content-Type': 'application/json',
      'Ocp-Apim-Trace': 'true'
    };
  }
  static ɵfac = function ApiService_Factory(t) {
    return new (t || ApiService)(i0.ɵɵinject(i0.Injector), i0.ɵɵinject(LIBRARY_CONFIG, 8));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ApiService,
    factory: ApiService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i0.Injector
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [LIBRARY_CONFIG]
    }]
  }], null);
})();
